import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import { TbLogout2, TbMenu2 } from 'react-icons/tb';
import classnames from 'classnames';
import { logout } from '../../../auth/AuthActions';

import { useLayoutContext } from '../../../contexts/useLayoutContext';

function Topbar() {
  const [isMobile, setIsMobile] = useState(null);
  const { sidenav, changeSideNavSize, showBackdrop } = useLayoutContext();

  const dispatch = useDispatch();

  const toggleSideNav = () => {
    const html = document.documentElement;
    const currentSize = html.getAttribute('data-sidenav-size');

    if (currentSize === 'offcanvas') {
      html.classList.toggle('sidebar-enable');
      showBackdrop();
    } else if (sidenav.size === 'compact') {
      changeSideNavSize(currentSize === 'compact' ? 'condensed' : 'compact', false);
    } else {
      changeSideNavSize(currentSize === 'condensed' ? 'default' : 'condensed');
    }
  };

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  return (
    <header className="app-topbar">
      <Container fluid className="topbar-menu">
        <div className={classnames('d-flex align-items-center gap-2', isMobile && 'my-2')}>
          <Button
            variant="primary"
            onClick={toggleSideNav}
            className="sidenav-toggle-button btn-icon"
          >
            <TbMenu2 className="fs-22" />
          </Button>
        </div>

        <div className="d-flex align-items-center gap-2">
          <div className="topbar-item d-sm-flex">
            <button
              onClick={() => dispatch(logout())}
              className="fs-xxl menu-logout"
              type="button"
            >
              <TbLogout2 className="fs-20" />
            </button>
          </div>
        </div>
      </Container>
    </header>
  );
}

export default Topbar;
